import React, { useState } from "react"
import { Copy, ExternalLink, Download, Check } from "lucide-react"
import { Button } from "src/components/ui/button"
import { qrCodeUrl } from "../api/qrCampaignsApi"

// Shows the campaign's QR code + public URL with copy / open / download actions.
// Only meaningful once the campaign is saved (needs an id + public_url).
export function QrCodePreview({ campaign }) {
  const [copied, setCopied] = useState(false)
  if (!campaign?.id) return null

  const url = campaign.public_url
  const pngUrl = qrCodeUrl(campaign.id, "png")

  function copy() {
    navigator.clipboard?.writeText(url).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="flex items-start gap-4">
        <img
          src={pngUrl}
          alt="QR code"
          width={120}
          height={120}
          className="h-[120px] w-[120px] rounded-lg border border-slate-100"
        />
        <div className="min-w-0 flex-1">
          <p className="text-[12px] font-medium uppercase tracking-wide text-slate-400">Public link</p>
          <p className="mt-1 break-all text-[13px] text-slate-700">{url}</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <Button type="button" variant="outline" size="sm" className="gap-1.5" onClick={copy}>
              {copied ? <Check className="h-3.5 w-3.5 text-emerald-600" /> : <Copy className="h-3.5 w-3.5" />}
              {copied ? "Copied" : "Copy link"}
            </Button>
            <a href={url} target="_blank" rel="noreferrer">
              <Button type="button" variant="outline" size="sm" className="gap-1.5">
                <ExternalLink className="h-3.5 w-3.5" /> Open
              </Button>
            </a>
            <a href={pngUrl} download={`qr-${campaign.subdomain}.png`}>
              <Button type="button" variant="outline" size="sm" className="gap-1.5">
                <Download className="h-3.5 w-3.5" /> Download QR
              </Button>
            </a>
          </div>
          {campaign.status !== "live" && (
            <p className="mt-2 text-[12px] text-amber-600">
              This campaign is {campaign.status}. Set it to “Live” for the link to work publicly.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
